import { useState } from 'react';
import { AxiosError } from 'axios';
import { INpsDetail } from '../interfaces';
import { getPartnerRatingNpsDetail } from '../api';

export function useGetPartnerRatingNpsDetail() {
  const [{ loading, data, error, success }, setData] = useState<{
    loading: boolean;
    error: string | null;
    data: Map<string, INpsDetail | null>;
    success: boolean;
  }>({ loading: false, error: null, data: new Map(), success: false });

  const fetchPartnerRatingNpsDetail = async (realEstateGuid: string, date: string) => {
    const mapKey = `${realEstateGuid}-${date}`;
    if (data.has(mapKey)) return;

    setData((prevState) => ({ ...prevState, loading: true, success: false }));

    try {
      const response = await getPartnerRatingNpsDetail(realEstateGuid, date);

      setData((prevState) => {
        const newData = new Map(prevState.data);
        newData.set(mapKey, response);
        return { ...prevState, data: newData, success: true };
      });
    } catch (error) {
      setData((prevState) => ({ ...prevState, error: (error as AxiosError).response?.data.message }));
    } finally {
      setData((prevState) => ({ ...prevState, loading: false }));
    }
  };

  return { loading, data, error, success, fetchPartnerRatingNpsDetail };
}
